import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { flatten } from '../utils/flatten';
import {
  HttpResponsesHandlersFactory,
  IHttpResponsesHandler,
} from '../handlers/http-responses-handler';
import { Observable } from 'rxjs';
import moment from 'moment';

export abstract class BaseDataService {
  constructor(
    protected http: HttpClient,
    protected handlersFactory: HttpResponsesHandlersFactory,
  ) {}

  protected handleRequest<TResult>(
    request: Observable<TResult>,
    reponseHandler: IHttpResponsesHandler,
    message?: string,
  ): Promise<TResult> {
    let promise = request.toPromise();
    if (reponseHandler) {
      return promise
        .then((response: TResult) => {
          if (reponseHandler.handleSuccess) {
            reponseHandler.handleSuccess(message);
          }
          return Promise.resolve(response);
        })
        .catch((errorResponse: HttpErrorResponse) => {
          console.log('ERROR RESPONSE HANDLER: ', errorResponse);
          //if (reponseHandler.handleError && reponseHandler.handleError(errorResponse)) {
          //    return Promise.resolve();
          return Promise.reject(errorResponse);
        });
    } else {
      return promise;
    }
  }

  public extractData(res: any) {
    return res;
  }
  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `Error Status: ${errorResponse.status} - ${
        errorResponse.statusText || ''
      } ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }

  protected constructHttpParams(body: any): HttpParams {
    let params = new HttpParams();
    let flattenBody = flatten(body);

    Object.keys(flattenBody).forEach((prop) => {
      if (flattenBody[prop] != null && flattenBody[prop] != undefined) {
        //When you transfer object to Get request, Date variables must be format according invariant culture, i.e. "yyyy-mm-dd" format
        if (moment(flattenBody[prop], 'DD/MM/YYYY', true).isValid()) {
          //console.log(moment(flattenBody[prop], 'DD/MM/YYYY').format('YYYY-MM-DD'));
          params = params.set(prop, moment(flattenBody[prop], 'DD/MM/YYYY').format('YYYY-MM-DD'));
        } else params = params.set(prop, encodeURIComponent(flattenBody[prop]));
      }
    });

    return params;
  }
}
